export default __webpack_public_path__ + "static/media/pic.bef63d0f.png";